import { createAction } from '@reduxjs/toolkit';
import {
  AddRestrictedWordsToGroupPayload,
  AddVariousWordsToGlobalPayload,
  AddVariousWordsToGlobalUndoPayload,
  AddWordsToGroupUndoPayload,
  DeleteGlobalRestrictedWordsPayload,
  DeleteRestrictedWordsFromGroupPayload,
  DeleteWordsPayload,
  MakeWordsGlobalPayload,
  UpdateRestrictedWordPayload,
  DeleteRestrictedWordsPayload,
  MakeWordsGlobalUndoPayload,
  DeleteWordUndoPayload,
  UpdateWordUndoPayload,
  DeleteGroupPayload,
  UpdateGroupPayload,
  AssignGroupToArticlePayload,
  FetchRestrictedWordPayload
} from './restrictedWordsTypes';

export const fetchRestrictedWordsInitData = createAction<number>(
  'restrictedWords/FETCH_INIT_DATA_REQUEST'
);

export const addGlobalRestrictedWords = createAction<Array<string>>(
  'restrictedWords/ADD_GLOBAL_WORDS'
);

export const addNewWordsToGlobal = createAction<Array<string>>(
  'restrictedWords/ADD_NEW_WORDS_TO_GLOBAL'
);

export const deleteWordsFromGlobal = createAction<DeleteGlobalRestrictedWordsPayload>(
  'restrictedWords/DELETE_WORDS_FROM_GLOBAL'
);

export const makeWordsGlobal = createAction<MakeWordsGlobalPayload>(
  'restrictedWords/MAKE_WORDS_GLOBAL'
);

export const makeWordsGlobalUndo = createAction<MakeWordsGlobalUndoPayload>(
  'restrictedWords/MAKE_WORDS_GLOBAL_UNDO'
);

export const addVariousWordsToGlobal = createAction<AddVariousWordsToGlobalPayload>(
  'restrictedWords/ADD_VARIOUS_WORDS_TO_GLOBAL'
);

export const addVariousWordsToGlobalUndo = createAction<AddVariousWordsToGlobalUndoPayload>(
  'restrictedWords/ADD_VARIOUS_WORDS_TO_GLOBAL_UNDO'
);

export const addWordsToGroup = createAction<AddRestrictedWordsToGroupPayload>(
  'restrictedWords/ADD_WORDS_TO_GROUP'
);

export const addWordsToGroupUndo = createAction<AddWordsToGroupUndoPayload>(
  'restrictedWords/ADD_WORDS_TO_GROUP_UNDO'
);

export const deleteWordsFromGroup = createAction<DeleteRestrictedWordsFromGroupPayload>(
  'restrictedWords/DELETE_WORDS_FROM_GROUP'
);

export const updateRestrictedWord = createAction<UpdateRestrictedWordPayload>(
  'restrictedWords/UPDATE_WORD_REQUEST'
);

export const deleteRestrictedWords = createAction<DeleteRestrictedWordsPayload>(
  'restrictedWords/DELETE_WORDS_REQUEST'
);
export const deleteWords = createAction<DeleteWordsPayload>('restrictedWords/DELETE_WORDS');

export const refreshRestrictedWordsData = createAction('restrictedWords/REFRESH_DATA');

export const deleteWordUndo = createAction<DeleteWordUndoPayload>(
  'restrictedWords/DELETE_WORD_UNDO'
);

export const updateWordUndo = createAction<UpdateWordUndoPayload>(
  'restrictedWords/UPDATE_WORD_UNDO'
);

export const fetchGroupArticles = createAction<number>(
  'restrictedWords/FETCH_GROUP_ARTICLES_REQUEST'
);

export const deleteGroup = createAction<DeleteGroupPayload>('restrictedWords/DELETE_GROUP_REQUEST');

export const deleteGroupUndo = createAction<DeleteGroupPayload>(
  'restrictedWords/DELETE_GROUP_UNDO'
);

export const updateRestrictedGroup = createAction<UpdateGroupPayload>(
  'restrictedWords/UPDATE_GROUP_REQUEST'
);

export const assignGroupToArticleUndo = createAction<AssignGroupToArticlePayload>(
  'restrictedWords/ASSIGN_GROUP_TO_ARTICLES_UNDO'
);

export const updateRestrictedGroupUndo = createAction<UpdateGroupPayload>(
  'restrictedWords/UPDATE_GROUP_UNDO'
);

export const assignGroupToArticle = createAction<AssignGroupToArticlePayload>(
  'restrictedWords/ASSIGN_GROUP_TO_ARTICLES_REQUEST'
);

export const fetchRestrictedGroups = createAction('restrictedWords/FETCH_ALL_GROUPS_REQUEST');

export const fetchRestrictedWord = createAction<FetchRestrictedWordPayload>(
  'restrictedWords/FETCH_WORD_REQUEST'
);
